export default class Constants {
    static HAMBURGER_SELECTOR = '#hamburger';
    static NAVLINKS_SELECTOR = '#nav_links';
    static ARROW_DOWN_SELECTOR = '.arrow-down'; //for opening/closing lists
    /** content opening **/
    static CONTENT_OPENER_SELECTOR = '.sadrzaj-opener'; //for opening/closing content
    static CONTENT_OPENER_CONTENT_SELECTOR = '.sadrzaj-content-item';
    static CONTENT_OPENER_CONTENT_TITLE_SELECTOR = '.sadrzaj-content-item-text';
    static CONTENT_OPENER_CONTENT_CONTENT_SELECTOR = '.sadrzaj-content-item-page';
    static CONTENT_OPENER_PLUS_IMAGE = '/public/images/icons/plus.svg';
    static CONTENT_OPENER_MINUS_IMAGE = '/public/images/icons/minus.svg';



}